<div class="card p-0 animate__animated animate__fadeIn">
  <div class="logo-auth">
    <img src="../../../assets/images/logo-auth.png" alt="" />
  </div>
  <div class="p-4">
    <h2 class="text-center mb-4 inter-Regular">Login</h2>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label for="email" class="form-label">Email address</label>
        <input
          type="email"
          formControlName="email"
          class="form-control"
          required
        />
        <div
          *ngIf="
            loginForm.get('email')?.invalid && loginForm.get('email')?.touched
          "
          class="text-danger"
        >
          <span *ngIf="loginForm.get('email')?.hasError('required')"
            >Email is required.</span
          >
          <span *ngIf="loginForm.get('email')?.hasError('pattern')"
            >Enter valid email ID.</span
          >
        </div>
      </div>

      <div class="mb-3">
        <label for="password" class="form-label float-start">Password</label>
        <label for="password" class="form-label float-end">
          <a
            routerLink="/forgotpassword"
            class="text-white text-decoration-none"
            >Forgot Password?</a
          >
        </label>
        <input
          type="password"
          formControlName="password"
          class="form-control"
          required
        />
        <div
          *ngIf="
            loginForm.get('password')?.invalid &&
            loginForm.get('password')?.touched
          "
          class="text-danger"
        >
          <span *ngIf="loginForm.get('password')?.hasError('required')"
            >Password is required.</span
          >
        </div>
      </div>

      <!-- <div class="form-check mb-3">
        <input class="form-check-input" type="checkbox" id="flexCheckDefault" />
        <label class="form-check-label" for="flexCheckDefault"
          >Remember me</label
        >
      </div> -->
      <div class="mb-4 text-end">
        <button
          type="submit"
          class="btn btn-warning rounded-pill text-white w-150px"
        >
          Login
        </button>
      </div>
      <div class="mb-3">
        <google-auth></google-auth>
      </div>
    </form>
  </div>
</div>

<!--<div class="">
  <form #frm="ngForm" (submit)="frm.form.valid && onSubmit(frm)">
    <div>
      <label for="username">Username:</label>
      <input
        type="email"
        name="email"
        ngModel
        #email="ngModel"
        required
        email
      />
      @if(frm.submitted && email.invalid) { @if(email.hasError('required')) {
      <span class="error-message">Email is required.</span>
      } @if(email.hasError('email')) {
      <span class="error-message">Invalid email format</span>
      } }
    </div>
    <div>
      <label for="password">Password:</label>
      <input
        type="password"
        name="password"
        ngModel
        #password="ngModel"
        required
      />
      @if(frm.submitted && password.invalid) {
      @if(password.hasError('required')) {
      <span class="error-message">Password is required.</span>
      } }
    </div>
    <button type="submit">Login</button>
  </form>
</div> -->
